import { writable } from "svelte/store";
import { onDestroy } from "svelte";
import { panelController, modalS } from "../../../stores/service";
import { modelValid } from "../../../Models/modelSystemG";
import { createNewDate } from "../../../Controller/APIs/date";
import { collection } from "@firebase/firestore";

const databeta = (data) => {
  const { subscribe, set, update } = writable(0);

  return {
    subscribe,
    sumar: () => {
      update((value) => {
        value = data;
        return value;
      });
    },
    reiniciar: () => {
      set({
        status: false,
        nuevo: false,
        carga: false,
        index: 0,
        btn: [
          {
            text: "Crear",
            status: false,
            style: "btn-light ",
            ico: "bi bi-plus-circle",
          },
          {
            text: "Guardar",
            status: false,
            style: "btn-light",
            ico: "bi bi-check2-circle",
          },
          {
            text: "Cancelar",
            status: false,
            style: "btn-light",
            ico: "bi bi-x-circle",
          },
        ],
        inputs: [
          /* Nombre */
          {
            active: true,
            value: "",
            valid: false,
            styletxt: "",
            messtxt: "",
          },
          /* email */
          {
            active: true,
            value: "",
            valid: false,
            styletxt: "",
            messtxt: "",
          },
          /* rol */
          {
            active: true,
            value: 0,
            valid: false,
            styletxt: "",
            messtxt: "",
          },
        ],
      });
    },
  };
};

function data() {
  return {
    status: false,
    nuevo: false,
    index: 0,
    btn: [
      {
        text: "Crear",
        status: false,
        style: "btn-light ",
        ico: "bi bi-plus-circle",
      },
      {
        text: "Guardar",
        status: false,
        style: "btn-light",
        ico: "bi bi-check2-circle",
      },
      {
        text: "Cancelar",
        status: false,
        style: "btn-light",
        ico: "bi bi-x-circle",
      },
    ],
    inputs: [
      /* Nombre */
      {
        active: true,
        value: "",
        valid: false,
        styletxt: "",
        messtxt: "",
      },
      /* email */
      {
        active: true,
        value: "",
        valid: false,
        styletxt: "",
        messtxt: "",
      },
      /* rol */
      {
        active: true,
        value: 0,
        valid: false,
        styletxt: "",
        messtxt: "",
      },
    ],
  };
}

function btncontrolA(opc) {
  dataViewRol.update((data) => {
    switch (opc) {
      case 1:
        /* Nuevo */
        data.btn[0].status = true;
        data.btn[1].status = false;
        data.btn[2].status = false;
        break;

      case 2:
        /* Guardar */
        data.btn[0].status = false;
        data.btn[1].status = true;
        data.btn[2].status = true;

        break;

      default:
        break;
    }
    return data;
  });
}

export const dataViewRol = writable(data());

export async function beginview(panelControl, dataView) {
  await controlDatadmin(3, panelControl, dataView);
}

export async function controlDatadmin(opc, panelControl, dataView) {

  switch (opc) {
    /* nuevo */
    case 0:
      dataValid("email");
      dataValid("name");
      dataValid("rol");
      dataView.btn[2].status = true;
      if (
        !(
          dataView.inputs[0].valid &&
          dataView.inputs[1].valid &&
          dataView.inputs[2].valid
        )
      ) {
        storedataView({ ...dataView });
        dataValid("email");
        dataValid("name");
        dataValid("rol");

        break;
      }

      dataView.btn[0].status = false;
      dataView.carga = true;
      
      
      if (panelControl.service.tableadmins.some(item => item.email == dataView.inputs[1].value)){
        Aviso(dataView.inputs[1].value)
        break;
      }

      if (dataView.nuevo) {
        await nuevoColaborador(dataView, panelControl);
      }

      dataView.carga = false;
      dataView.btn[0].status = true;
      storedataView({ ...dataView });
      break;

    case 1:
      /* guardar cambios */
      if (
        !(
          dataView.inputs[0].valid &&
          dataView.inputs[1].valid &&
          dataView.inputs[2].valid
        )
      ) {
        dataValid("email");
        dataValid("name");
        dataValid("rol");
        break;
      }

      panelControl.service.tableadmins[dataView.index].email =
        dataView.inputs[1].value;

      panelControl.service.tableadmins[dataView.index].name =
        dataView.inputs[0].value;

      panelControl.service.tableadmins[dataView.index].admin = dataView
        .inputs[2].value
        ? 1
        : 2;

        let data = await modelValid({
          doc: "update",
          data:{
            collection:'service',
            id:panelControl.firebase.docs[0].id,
            data:panelControl.service
          }
        });

      if (data.status) {
        await controlDatadmin(3, panelControl, dataView);
        storePanelcontrol(panelControl);
      }

      break;

    case 2:
      /* cancelar */
      await controlDatadmin(3, panelControl, dataView);
      break;
    case 3:
      /* inicio */
      dataView.status = true;
      dataView.nuevo = true;
      storedataView({ ...dataView });
      inputsControl(1, 0);
      inputsControl(1, 1);
      inputsControl(1, 2);
      btncontrolA(1);

      break;
    default:
      break;
  }
}

function storedataView(dataView) {

  dataViewRol.update((data) => {
    data = dataView;
    return data;
  });
}

function storePanelcontrol(panelControl) {
  panelController.update((pc) => {
    pc = panelControl;
    return pc;
  });
}

async function nuevoColaborador(viewConfiguracion, panelService) {
  let currentDate = await createNewDate("America/Mexico_City");

  if (!currentDate.status) {
    return;
  }

  panelService.service.admins.push({
    email: viewConfiguracion.inputs[1].value,
  });

  panelService.service.tableadmins.push({
    name: viewConfiguracion.inputs[0].value,
    email: viewConfiguracion.inputs[1].value,
    date: `${currentDate.day}-${currentDate.month}-${currentDate.year}`,
    admin: viewConfiguracion.inputs[2].value == 1 ? true : false,
  });

  let data = await modelValid({
    doc: "update",
    data:{
      collection:'service',
      id:panelService.firebase.docs[0].id,
      data:panelService.service
    }
  });

  if (data.status && currentDate.status) {
    storePanelcontrol(panelService);
    controlDatadmin(3, panelService, viewConfiguracion);
  }
}

function inputsControl(opc, index) {
  dataViewRol.update((data) => {
    switch (opc) {
      case 1:
        /* neutro */
        data.inputs[index].value = "";
        data.inputs[index].active = false;
        data.inputs[index].messtxt = "";
        data.inputs[index].valid = false;
        break;
      case 2:
        /* verdadero */

        data.inputs[index].messtxt = "Correcto";
        data.inputs[index].valid = true;
        data.inputs[index].styletxt = "valid-c";
        break;
      case 3:
        /* invalido */

        data.inputs[index].messtxt = "No valido";
        data.inputs[index].valid = false;
        data.inputs[index].styletxt = "valid-i";
        break;
      case 4:
        /* editar */
        data.inputs[index].value = "";
        data.inputs[index].active = false;
        data.inputs[index].messtxt = "";
        data.inputs[index].valid = true;
        break;

      default:
        break;
    }
    return data;
  });
}

export function dataValid(opc, value) {
  dataViewRol.update((data) => {
    switch (opc) {
      case "name":
        const invalidCharsname = findInvalidCharacters(
          data.inputs[0].value,
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789,¿?:;áéíóúÁÉÍÓÚñÑ "
        );

        if (invalidCharsname) {
          inputsControl(3, 0);
          data.inputs[0].messtxt = `Caracteres inválidos: ${invalidCharsname.join(
            ", "
          )}`;
        } else {
          inputsControl(2, 0);
          data.inputs[0].messtxt = `Valido`;
        }

        if (data.inputs[0].value.length == 0) {
          inputsControl(3, 0);
          data.inputs[0].messtxt = `Llene correctamente el formulario`;
        }
        if (data.inputs[0].value.length > 60) {
          inputsControl(3, 0);
          data.inputs[0].messtxt = `Muy largo`;
        }

        break;
      case "email":
        const invalidCharsemail = findInvalidCharacters(
          data.inputs[1].value,
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789,¿?:;áéíóúÁÉÍÓÚñÑ@. "
        );

        if (invalidCharsemail) {
          inputsControl(3, 1);
          data.inputs[1].messtxt = `Caracteres inválidos encontrados: ${invalidCharsemail.join(
            ", "
          )}`;
        } else {
          inputsControl(2, 1);
          data.inputs[1].messtxt = `Valido`;
        }

        if (data.inputs[1].value.length == 0) {
          inputsControl(3, 1);
          data.inputs[1].messtxt = `Llene correctamente el formulario`;
        }
        if (data.inputs[1].value.length > 60) {
          inputsControl(3, 1);
          data.inputs[1].messtxt = `Muy largo`;
        }

        break;

      case "rol":
        if (0 < data.inputs[2].value && 3 > data.inputs[2].value) {
          inputsControl(2, 2);
          data.inputs[2].messtxt = `Selecionado`;
        }
        if (data.inputs[2].value == 0) {
          inputsControl(3, 2);
          data.inputs[2].messtxt = `No selecionado`;
        }
        break;

      default:
        break;
    }
    return data;
  });
}

function findInvalidCharacters(input, allowedChars) {

  // Crear un conjunto de caracteres permitidos para facilitar la búsqueda
  const allowedSet = new Set(allowedChars);

  // Crear un arreglo para almacenar los caracteres inválidos
  const invalidChars = [];

  // Recorrer cada carácter de la cadena de entrada
  for (const char of input) {
    if (!allowedSet.has(char)) {
      invalidChars.push(char); // Si el carácter no está permitido, agregarlo al arreglo
    }
  }

  // Imprimir o devolver los caracteres inválidos
  return invalidChars.length > 0 ? invalidChars : null;
}

export async function controltableA(opc, index, panelControl, dataView) {
  switch (opc) {
    case 0:
      /* eliminar */

      if (
        await confirmarEditar(panelControl.service.tableadmins[index].email)
      ) {
        panelControl.service.admins.splice(index, 1);
        panelControl.service.tableadmins.splice(index, 1);

        let data = await modelValid({
          doc: "update",
          data:{
            collection:'service',
            id:panelControl.firebase.docs[0].id,
            data:panelControl.service
          }
        });

        if (data.status) {
          storePanelcontrol(panelControl);
        }
      }
      break;

    case 1:
      /* editar */
      inputsControl(4, 0);
      inputsControl(4, 1);
      inputsControl(4, 2);
      dataView.inputs[1].value = panelControl.service.tableadmins[index].email;

      dataView.inputs[0].value = panelControl.service.tableadmins[index].name;

      dataView.inputs[2].value = panelControl.service.tableadmins[index].admin
        ? 1
        : 2;

      dataView.index = index;

      dataView.inputs[1].valid = true;
      dataView.inputs[0].valid = true;
      dataView.inputs[2].valid = true;

      if (
        panelControl.service.tableadmins[0].email ===
        panelControl.service.tableadmins[index].email
      ) {
        dataView.inputs[2].active = true;
        dataView.inputs[1].active = true;
      }

      storedataView(dataView);
      btncontrolA(2);

      break;

    default:
      break;
  }
}

export async function confirmarEditar(data) {
  let res;
  modalS.update((values) => {
    values.reset();
    values.info.title = "Aviso";
    values.info.body = `Desea eliminar a ${data}`;
    values.controllers.btn[0].text = `Si, eliminar`;
    values.controllers.btn[1].text = `No, cancelar`;
    values.controllers.btn[0].status = true;
    values.controllers.btn[1].status = true;
    values.status = true;
    return values;
  });

  return new Promise((resolve, reject) => {
    modalS.update((value) => {
      value.resolve = resolve;
      value.reject = reject;
      return value;
    });
  });
}

export async function Aviso(data) {
  let res;
  modalS.update((values) => {
    values.reset();
    values.info.title = "Aviso";
    values.info.body = `El usuario ${data} ya se encuantra registrado.`;
    values.controllers.btn[0].text = `Aceptar`;
    values.controllers.btn[1].text = ``;
    values.controllers.btn[0].status = true;
    values.controllers.btn[1].status = false;
    values.status = true;
    return values;
  });

  return new Promise((resolve, reject) => {
    modalS.update((value) => {
      value.resolve = resolve;
      value.reject = reject;
      return value;
    });
  });
}